<template>
  <a-layout-sider
    class="sidebar"
    v-if="!!user && fMenuItems.length > 0"
    breakpoint="lg"
    collapsed-width="0"
    theme="light"
  >
    <a-menu mode="inline" :items="fMenuItems" @click="handleClick"></a-menu>
  </a-layout-sider>
</template>

<script src="./index.js"></script>
<style src="./style.less" lang="less" scoped></style>
